var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkPrototype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.4995,
    r: 40.5,
    fill: "#FBDFA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.7062 35.1588V30.2649C55.7062 29.9404 55.5742 29.6292 55.3393 29.3997C55.1044 29.1703 54.7858 29.0414 54.4536 29.0414H29.402C29.0698 29.0414 28.7512 29.1703 28.5163 29.3997C28.2814 29.6292 28.1494 29.9404 28.1494 30.2649V35.1588H55.7062Z",
    fill: "#E27007"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1494 37.6058V54.7346C28.1494 55.0591 28.2814 55.3703 28.5163 55.5998C28.7512 55.8292 29.0698 55.9581 29.402 55.9581H35.6649V37.6058H28.1494Z",
    fill: "#E27007"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1699 55.9581H54.4534C54.7857 55.9581 55.1043 55.8292 55.3392 55.5998C55.5741 55.3703 55.706 55.0591 55.706 54.7346V37.6058H38.1699V55.9581Z",
    fill: "#E27007"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPrototype);
export default __webpack_public_path__ + "static/media/workPrototype.10c152bf820acf051356a8e1f85b1460.svg";
export { ForwardRef as ReactComponent };